export const pushToDataLayer = (event: string, data?: Record<string, any>) => {
    if (typeof window !== "undefined") {
        window.dataLayer = window.dataLayer || [];

        if (event === "cookie_consent_update") {
            const alreadyPushed = window.dataLayer.some((e: any) => e.event === "cookie_consent_update");
            if (alreadyPushed) return;
        }

        window.dataLayer.push({ event, ...data });
    }
};

export const pushConsentStatusToDataLayer = () => {
    if (typeof window === "undefined") return;

    const cookies = document.cookie;
    const granted = (key: string) =>
        cookies.includes(`cookie_consent=${key}`) || cookies.includes(`gdpr_settings_${key}=granted`) || cookies.includes(`${key}_storage=granted`)
            ? "granted"
            : "denied";

    pushToDataLayer("cookie_consent_update", {
        consent: {
            ad_storage: granted("marketing"),
            analytics_storage: granted("analytics"),
            ad_user_data: granted("marketing"),
            ad_personalization: granted("marketing"),
            functionality_storage: "granted",
            personalization_storage: granted("marketing"),
            security_storage: "granted",
        },
    });
};
